// This icon file is generated automatically.
var PSwapOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.25 7.25H.37a.13.13 0 00-.12.13v.93c0 .07.06.13.13.13h9.45L7.58 11.3c-.07.08-.01.2.1.2H8.8c.07 0 .15-.03.2-.1l2.63-3.34a.5.5 0 00-.4-.81zm.38-3.69H2.16L4.42.7c.07-.08.01-.2-.1-.2H3.2a.25.25 0 00-.2.1L.37 3.94a.5.5 0 00.39.81h10.88c.06 0 .12-.06.12-.13V3.7a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-swap", "theme": "outlined" };
export default PSwapOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSwapOutlined.js
// module id = 3671
// module chunks = 0